/** @format */

import { Alert, Button, Form, Input, Modal } from "antd";
import { useCallback } from "react";

type ModalValidType = {
  openModal: any;
  loading: boolean;
  title: any;
  files: any;
  filesDoc: any;
  dataMadrasah: any;
  handleValidation: (e: any) => void;
  handleClose: () => void;
};
export const ModalValidationDokumenBos = ({
  openModal,
  title,
  files,
  filesDoc,
  loading,
  dataMadrasah,
  handleValidation,
  handleClose,
}: ModalValidType) => {
  const [form] = Form.useForm();
  const handleSave = useCallback(
    (values: any) => {
      const payload = {
        id: filesDoc?.id || null,
        keterangan: values?.keterangan || "",
        statusValid: values?.keterangan ? 2 : 1,
      };
      handleValidation(payload);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filesDoc, dataMadrasah, files],
  );

  const modalReset = useCallback(() => {
    form.resetFields();
    handleClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataMadrasah, files]);

  return (
    <Modal
      key={"modalValidationDokBos"}
      open={openModal}
      width={1200}
      title={`Approval Dokumen ${title}`}
      onCancel={modalReset}
      footer={[
        <Button key={"btnkvdb"} loading={loading} onClick={modalReset}>
          Kembali
        </Button>,
        <Button
          key={"btntvdb"}
          loading={loading}
          disabled={(dataMadrasah?.statusValidasi === 1 && true) || false}
          onClick={() => form.submit()}
          danger>
          Tolak Dokumen
        </Button>,
        <Button
          key={"btnsvdb"}
          loading={loading}
          type="primary"
          onClick={() => handleSave(1)}>
          Disetujui
        </Button>,
      ]}>
      {filesDoc?.typeDoc === "application/pdf" ? (
        <object
          aria-labelledby="rkam"
          data={files}
          type={filesDoc?.typeDoc}
          width="100%"
          height="400px"></object>
      ) : (
        <>
          <Alert
            message="Informasi"
            description="File excel sudah berhasil di download, mohon diperiksa kembali!"
            type="info"
            showIcon
          />
        </>
      )}
      <div className="py-4">
        <Form
          form={form}
          key="formAprrovalDocument"
          name="formAprrovalDocument"
          labelAlign="left"
          onFinish={handleSave}>
          <Form.Item
            rules={[
              {
                required: true,
                message: "Keterangan tidak boleh kosong!",
              },
            ]}
            label="Keterangan"
            name="keterangan">
            <Input.TextArea placeholder="Keterangan" />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};
